// components/ModalPortal.jsx

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

const ModalPortal = ({ children }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true); // Set mounted to true after the component mounts
    return () => setMounted(false); // Cleanup on component unmount
  }, []);

  // Only render the portal if it's mounted
  if (!mounted) return null;

  return ReactDOM.createPortal(children, document.body);
};

export default ModalPortal;
